module.exports = __webpack_public_path__ + "img/incidents-and-complaints.5db1441d.svg";